import { InlineComposer, type ComposerDrawerPayload, type ComposerMode } from '../shared/timeline/InlineComposer';
import { useDealComposerSaves } from './useDealComposerSaves';

export interface DealComposerHostProps {
  dealId: string;
  dealLeadId?: string | null;
  dealClientId?: string | null;
  onSaved: () => void | Promise<void>;
  onOpenDrawer: (mode: ComposerMode, payload: ComposerDrawerPayload) => void;
}

/**
 * Host del composer inline nella cronologia di un'offerta. Stessa ragione d'essere del
 * gemello lato lead (`LeadComposerHost`, fix round 1 I2): l'hook dei salvataggi — e con lui
 * la sottoscrizione al calendar store di `useActivitySave` — viene montato SOLO dove il
 * composer è effettivamente richiesto, senza chiamate condizionali di hook.
 */
export function DealComposerHost({
  dealId,
  dealLeadId,
  dealClientId,
  onSaved,
  onOpenDrawer,
}: DealComposerHostProps) {
  const saves = useDealComposerSaves({ dealId, dealLeadId, dealClientId });

  return (
    <InlineComposer
      onSaveNote={async (html) => {
        await saves.saveNote(html);
        await onSaved();
      }}
      onSaveActivity={async (input) => {
        await saves.saveActivity(input);
        await onSaved();
      }}
      onOpenDrawer={onOpenDrawer}
    />
  );
}

export default DealComposerHost;
